export const clampNonNegativeNumber = (value: unknown): number => {
  const parsed = typeof value === 'number' ? value : Number.parseFloat(String(value));
  if (!Number.isFinite(parsed)) return 0;
  return Math.max(0, parsed);
};

export const normalizeText = (value: unknown, maxLength: number): string => {
  if (typeof value !== 'string') return '';
  return value.trim().slice(0, maxLength);
};

export const getEnvNumber = (value: string | undefined, fallback: number): number => {
  if (!value) return fallback;
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const sanitizeCsvField = (value: unknown): string => {
  const text = String(value ?? '');
  const needsFormulaEscape = /^[=+\-@]/.test(text);
  const safeText = needsFormulaEscape ? `'${text}` : text;
  const escaped = safeText.replace(/"/g, '""');
  return `"${escaped}"`;
};
